import { c as _c } from "react/compiler-runtime";
import { graphql, readFragment } from "@opensea/graphql";
import { UnstyledButton } from "@opensea/ui-kit";
import { CollectionWatchlistIcon } from "./CollectionWatchlistIcon";
import { useToggleWatchCollection, useToggleWatchCollectionFragment } from "./use-toggle-watch-collection";
export const CollectionWatchlistButtonFragment = graphql(`
  fragment CollectionWatchListButton on Collection {
    ...useToggleWatchCollection
  }
`, [useToggleWatchCollectionFragment]);
export function CollectionWatchlistButton(t0) {
  const $ = _c(14);
  const {
    collection: collectionKey,
    initialState
  } = t0;
  let t1;
  if ($[0] !== collectionKey) {
    t1 = readFragment(CollectionWatchlistButtonFragment, collectionKey);
    $[0] = collectionKey;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const collection = t1;
  let t2;
  if ($[2] !== collection || $[3] !== initialState.isWatched) {
    t2 = {
      collection,
      isWatching: initialState.isWatched
    };
    $[2] = collection;
    $[3] = initialState.isWatched;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const toggleWatch = useToggleWatchCollection(t2);
  let t3;
  if ($[5] !== toggleWatch) {
    t3 = async ev => {
      ev.preventDefault();
      await toggleWatch.execute();
    };
    $[5] = toggleWatch;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const handleWatch = t3;
  const isFetching = initialState.fetching || toggleWatch.fetching;
  let t4;
  if ($[7] !== isFetching || $[8] !== toggleWatch.isWatching) {
    t4 = <CollectionWatchlistIcon isFilled={toggleWatch.isWatching} loading={isFetching} />;
    $[7] = isFetching;
    $[8] = toggleWatch.isWatching;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== handleWatch || $[11] !== isFetching || $[12] !== t4) {
    t5 = <UnstyledButton disabled={isFetching} onClick={handleWatch}>{t4}</UnstyledButton>;
    $[10] = handleWatch;
    $[11] = isFetching;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}